import { ApolloClient, NormalizedCacheObject, InMemoryCache, HttpLink } from '@apollo/client';
import { PropsWithChildren, useRef } from 'react';

import { useWorkspaceAliasQuery } from 'generated/graphql';
import FullPageLoadingContainer from 'packages/kakapo-ui-application/pages/loading/FullPageLoadingContainer';
import {
	WorkspaceProvider as BaseWorkSpaceProvider,
	useWorkspaceAlias,
} from 'packages/kakapo-ui-services/hooks/useWorkspace';

export const WorkspaceProvider = ({ children }: PropsWithChildren) => {
	const client = useRef<ApolloClient<NormalizedCacheObject> | undefined>(undefined);

	if (!client.current) {
		client.current = new ApolloClient({
			cache: new InMemoryCache(),
			link: new HttpLink({
				uri: import.meta.env.VITE_GRAPHQL ?? 'https://api.ontreams.com/graphql',
				fetch: (info, init) => fetch(info, init),
			}),
		});
	}

	const alias = useWorkspaceAlias();
	const { data } = useWorkspaceAliasQuery({ client: client.current, variables: { alias } });
	const workspace = data?.workspaceAlias ? { id: data.workspaceAlias.id } : undefined;

	return workspace ? (
		<BaseWorkSpaceProvider value={workspace}>{children}</BaseWorkSpaceProvider>
	) : (
		<FullPageLoadingContainer />
	);
};
